import { makeAutoObservable } from "mobx";

let _id = 0;

export interface InjectBaseModalProps {
  visible?: boolean;

  onCancel?(): void;

  [key: string]: any;
}

type InjectComponent<T> =
  | React.FunctionComponent<T>
  | React.ForwardRefExoticComponent<T>
  | React.ClassicComponentClass<T>
  | React.ComponentClass<T>;

export class ModalStore {
  constructor() {
    makeAutoObservable(this, undefined, {
      autoBind: true,
    });
  }

  modalsMapping = new Map<number, any>();

  modalPropsMapping = new Map<number, any>();

  get needToRenderChildrenIds() {
    const ids: number[] = [];

    this.modalsMapping.forEach((el, key) => {
      ids.push(key);
    });

    return ids;
  }

  // 销毁
  dispose() {
    this.modalPropsMapping.clear();
    this.modalsMapping.clear();
  }

  updateModalProps(modalId: number, updateProps: any) {
    const oldProps = this.modalPropsMapping.get(modalId);

    if (!oldProps) {
      this.modalsMapping.delete(modalId);
      this.modalPropsMapping.delete(modalId);

      return;
    }

    const newProps: InjectBaseModalProps = {
      ...oldProps,
      ...updateProps,
    };

    this.modalPropsMapping.set(modalId, newProps);

    if (newProps.visible === false) {
      this.modalsMapping.delete(modalId);
      this.modalPropsMapping.delete(modalId);
    }
  }

  openModal<T extends InjectBaseModalProps>(Component: InjectComponent<T>, injectProps?: T) {
    const modalId = _id++;

    const onCancel = () => {
      try {
        injectProps?.onCancel?.();
      } catch (error) {}

      const newProps = this.modalPropsMapping.get(modalId);

      newProps.visible = false;

      setTimeout(() => {
        this.modalsMapping.delete(modalId);
        this.modalPropsMapping.delete(modalId);
      }, 300);
    };

    const props: InjectBaseModalProps = {
      ...injectProps,
      visible: true,
      onCancel,
    };

    this.modalPropsMapping.set(modalId, props);
    this.modalsMapping.set(modalId, Component);

    return {
      modalId,
      onCancel,
    };
  }
}
